module.exports = __webpack_public_path__ + "view_magnify.f9042.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/view_magnify.svg
// module id = ./src/_asset/sources/assets/images/@svg/view_magnify.svg
// module chunks = main